import { type FC } from 'react';

interface CategoryItem {
  name: string;
  url: string;
  icon: string;
  description: string;
  imageUrl: string;
}

const categoryData: CategoryItem[] = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    description: 'Sneaker, Sportschuhe & Luxus-Schuhe aus China',
    imageUrl: 'https://readdy.ai/api/search-image?query=Pair%20of%20premium%20white%20leather%20sneakers%20with%20gold%20accents%20placed%20on%20a%20textured%20cream%20linen%20fabric%20soft%20diffused%20window%20light%20casting%20delicate%20shadows%20minimalist%20editorial%20product%20photography%20clean%20european%20aesthetic%20warm%20sandy%20beige%20tones&width=800&height=600&seq=cat-shoes-v3&orientation=landscape&nocache=true',
  },
  {
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    description: 'Hoodies, Sweater & Pullover von Top-Sellern',
    imageUrl: 'https://readdy.ai/api/search-image?query=Oversized%20oatmeal%20knit%20sweater%20draped%20elegantly%20over%20a%20wooden%20chair%20with%20dried%20pampas%20grass%20in%20ceramic%20vase%20warm%20afternoon%20sunlight%20creating%20soft%20highlights%20editorial%20fashion%20photography%20neutral%20earthy%20palette&width=800&height=600&seq=cat-hoodies-v3&orientation=landscape&nocache=true',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-t-shirt-air-line',
    description: 'Bedruckte & einfarbige T-Shirts',
    imageUrl: 'https://readdy.ai/api/search-image?query=Folded%20premium%20cotton%20tshirt%20in%20sage%20green%20color%20on%20a%20natural%20linen%20surface%20with%20a%20sprig%20of%20dried%20lavender%20beside%20it%20soft%20morning%20light%20from%20left%20side%20gentle%20shadows%20clean%20minimalist%20product%20styling&width=800&height=600&seq=cat-tshirts-v3&orientation=landscape&nocache=true',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-shirt-line',
    description: 'Winterjacken, Windbreaker & Lederjacken',
    imageUrl: 'https://readdy.ai/api/search-image?query=Classic%20camel%20wool%20coat%20hanging%20on%20a%20minimal%20wooden%20hanger%20against%20a%20warm%20plaster%20wall%20with%20soft%20natural%20light%20creating%20gentle%20gradient%20shadows%20editorial%20fashion%20photography%20rich%20textured%20fabric%20details&width=800&height=600&seq=cat-jackets-v3&orientation=landscape&nocache=true',
  },
  {
    name: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
    description: 'Jeans, Cargohosen & Shorts',
    imageUrl: 'https://readdy.ai/api/search-image?query=Wellfitted%20beige%20chino%20trousers%20laid%20flat%20on%20a%20textured%20cream%20surface%20with%20a%20leather%20belt%20beside%20it%20soft%20natural%20daylight%20clean%20minimalist%20product%20photography%20european%20casual%20style%20subtle%20fabric%20texture%20visible&width=800&height=600&seq=cat-pants-v3&orientation=landscape&nocache=true',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-user-5-line',
    description: 'Caps, Beanies & Bucket Hats',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20cream%20colored%20baseball%20cap%20placed%20on%20a%20stack%20of%20art%20books%20on%20a%20warm%20wooden%20table%20with%20soft%20afternoon%20light%20streaming%20through%20sheer%20curtains%20minimalist%20aesthetic%20editorial%20still%20life%20clean%20composition&width=800&height=600&seq=cat-headwear-v3&orientation=landscape&nocache=true',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    description: 'Komplette Outfit-Sets & Bundles',
    imageUrl: 'https://readdy.ai/api/search-image?query=Curated%20outfit%20ensemble%20consisting%20of%20linen%20blazer%20white%20shirt%20and%20tailored%20trousers%20arranged%20artistically%20on%20a%20warm%20beige%20backdrop%20with%20dried%20botanicals%20soft%20directional%20lighting%20editorial%20fashion%20styling&width=800&height=600&seq=cat-sets-v3&orientation=landscape&nocache=true',
  },
  {
    name: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-checkbox-blank-line',
    description: 'Unterwäsche & Basics',
    imageUrl: 'https://readdy.ai/api/search-image?query=Soft%20organic%20cotton%20basics%20neatly%20folded%20on%20a%20warm%20terracotta%20linen%20surface%20with%20a%20small%20ceramic%20dish%20holding%20delicate%20gold%20jewelry%20beside%20it%20soft%20hazy%20morning%20light%20minimalist%20sensual%20product%20photography&width=800&height=600&seq=cat-underwear-v3&orientation=landscape&nocache=true',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-football-line',
    description: 'Fußball- & Basketball-Trikots',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vintage%20style%20soccer%20jersey%20in%20deep%20forest%20green%20with%20gold%20detailing%20laid%20flat%20on%20a%20rustic%20wooden%20surface%20with%20soft%20natural%20window%20light%20creating%20moody%20shadows%20editorial%20sportswear%20photography&width=800&height=600&seq=cat-jersey-v3&orientation=landscape&nocache=true',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-glasses-line',
    description: 'Schmuck, Uhren & Sonnenbrillen',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20arrangement%20of%20gold%20minimalist%20jewelry%20including%20thin%20chain%20necklace%20delicate%20rings%20and%20classic%20wristwatch%20on%20a%20warm%20marble%20surface%20with%20soft%20candlelight%20glow%20editorial%20luxury%20product%20photography&width=800&height=600&seq=cat-accessories-v3&orientation=landscape&nocache=true',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-handbag-line',
    description: 'Rucksäcke, Taschen & Koffer',
    imageUrl: 'https://readdy.ai/api/search-image?query=Structured%20tan%20leather%20tote%20bag%20standing%20on%20a%20warm%20cream%20surface%20with%20a%20silk%20scarf%20draped%20beside%20it%20soft%20natural%20light%20revealing%20rich%20leather%20grain%20texture%20editorial%20product%20photography%20elegant%20simplicity&width=800&height=600&seq=cat-bags-v3&orientation=landscape&nocache=true',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    description: 'Ledergürtel & Designergürtel',
    imageUrl: 'https://readdy.ai/api/search-image?query=Coiled%20premium%20dark%20brown%20leather%20belt%20with%20brushed%20brass%20buckle%20resting%20on%20a%20warm%20linen%20textile%20with%20soft%20directional%20light%20casting%20elongated%20shadows%20minimalist%20accessory%20photography%20rich%20texture%20details&width=800&height=600&seq=cat-belts-v3&orientation=landscape&nocache=true',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    description: 'Parfüm & Düfte',
    imageUrl: 'https://readdy.ai/api/search-image?query=Artistic%20arrangement%20of%20three%20amber%20glass%20perfume%20bottles%20on%20a%20warm%20cream%20marble%20pedestal%20with%20scattered%20dried%20rose%20petals%20and%20soft%20golden%20hour%20backlight%20creating%20luminous%20reflections%20editorial%20beauty%20photography&width=800&height=600&seq=cat-perfumes-v3&orientation=landscape&nocache=true',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    description: 'Weitere Produkte & Sonderartikel',
    imageUrl: 'https://readdy.ai/api/search-image?query=Eclectic%20curated%20collection%20of%20lifestyle%20items%20including%20ceramic%20mug%20leather%20notebook%20metal%20pen%20and%20woven%20basket%20on%20a%20warm%20oak%20surface%20with%20soft%20natural%20light%20editorial%20still%20life%20composition%20cozy%20aesthetic&width=800&height=600&seq=cat-other-v3&orientation=landscape&nocache=true',
  },
];

const CategoryCard: FC<{ cat: CategoryItem; isDark: boolean }> = ({ cat, isDark }) => (
  <a
    href={cat.url}
    target="_blank"
    rel="noopener nofollow"
    className={`group relative rounded-lg overflow-hidden cursor-pointer transition-transform hover:scale-[1.02] ${
      isDark ? 'bg-foreground-900' : 'bg-background-50'
    }`}
  >
    <div className={`aspect-[4/3] relative overflow-hidden ${isDark ? 'opacity-80' : ''}`}>
      <img
        src={cat.imageUrl}
        alt={`${cat.name} Kategorie`}
        title={`${cat.name} Spreadsheet Deutschland`}
        className="w-full h-full object-cover object-top"
        loading="lazy"
      />
    </div>
    <div className={`p-4 md:p-5 ${isDark ? '' : 'border-t border-background-200/60'}`}>
      {!isDark && (
        <span className="inline-flex items-center gap-1 text-xs text-primary-600 bg-primary-100/70 px-2 py-0.5 rounded-full mb-2">
          <i className="ri-check-line text-xs"></i>
          Verfügbar
        </span>
      )}
      <h3 className={`font-heading text-lg md:text-xl font-semibold ${isDark ? 'text-background-50' : 'text-foreground-950'}`}>
        {cat.name}
      </h3>
      <p className={`text-sm mt-1 ${isDark ? 'text-background-50/60' : 'text-foreground-600'}`}>
        {cat.description}
      </p>
    </div>
  </a>
);

export default function CategoryGrid() {
  const groups: CategoryItem[][] = [];
  for (let i = 0; i < categoryData.length; i += 3) {
    groups.push(categoryData.slice(i, i + 3));
  }

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">Produktkategorien</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl">
            Entdecke unsere beliebtesten Kategorien und finde die besten Produkte von Taobao, Weidian & Yupoo.
          </p>
        </div>

        <div className="flex flex-col gap-8">
          {groups.map((group, groupIdx) => (
            <div key={groupIdx} className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
              {group.map((cat, idx) => (
                <CategoryCard key={cat.name} cat={cat} isDark={idx === 0} />
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}